<div class="header">
  <div class="content">
    <div class="contentInner">
      <div class="pageTitle" appReveal>
        <h1 class="headline">Dash Blog</h1>
      </div>
    </div>
  </div>
</div>
<div class="content">
  <div class="contentInner">
    <p class="intro">Product news, setup tips and practical advice on running meeting room displays with Dash, from the team that builds it.</p>

    <ul class="postList">
      <li class="postCard" *ngFor="let post of posts" appReveal>
        <a class="postThumbnail" [routerLink]="['/blog', post.slug]" tabindex="-1" aria-hidden="true">
          <app-illustration [src]="post.heroImage.src"
                            [webpSrc]="post.heroImage.webpSrc"
                            [alt]="post.heroImage.alt"
                            [width]="post.heroImage.width"
                            [height]="post.heroImage.height"
                            [clickable]="false"></app-illustration>
        </a>
        <div class="postSummary">
          <h2><a [routerLink]="['/blog', post.slug]">{{ post.title }}</a></h2>
          <p class="postDate"><time [attr.datetime]="post.datePublished">{{ post.displayDate }}</time></p>
          <p>{{ post.description }}</p>
          <p class="readMore"><a [routerLink]="['/blog', post.slug]">Read more</a></p>
        </div>
      </li>
    </ul>

    <p class="empty" *ngIf="!posts.length">There are no posts here yet — check back soon.</p>
  </div>
</div>
